<script>
import { Bar, mixins } from 'vue-chartjs'

export default {
  extends: Bar,
  mixins: [mixins.reactiveProp],
  props: ['chartData', 'options'],
  mounted () {
    this.renderChart(this.chartData, this.options) // "chartData"は予約ワードの模様。文字列を変更するとエラー
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ChartBar.vue